module.exports = __webpack_public_path__ + "img/icon5.444beda4.png";